<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-6 lg:pt-10 pb-14 " v-else>
        <div class="container">
            <section class="lg:grid lg:grid-cols-24 lg:gap-6 flex flex-col">
                <div class="xl:col-span-18 xl:col-start-4 col-span-20 col-start-3">
                    <h2 class="text-3xl font-bold mb-3">
                        {{ $route.params.id ? __('Edit sale route') : __('Add sale route')
                        }}
                    </h2>
                    <div class="bg-white dark:bg-base-300 rounded-2xl md:px-6 px-3 sm:pb-6 sm:pt-4 py-2">
                        <Form @submit="onSubmit" v-slot="{ errors }">
                            <div class="grid grid-cols-1 md:gap-x-6 gap-y-4">
                                <div class="flex flex-col">
                                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                                        {{ __('Title') }} <span class="text-error">*</span>
                                    </label>
                                    <Field as="input" name="title" :class="{ 'input-error': errors.title }"
                                        rules="required" class="input" v-model="saleRoute.title" />
                                </div>
                                <div class="flex justify-between items-center mt-8 mb-6">
                                    <h3
                                        class="flex items-center md:text-26 text-xl dark:text-white text-biscay-700 font-semibold">
                                        <i
                                            class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                                        {{ __('Routes') }}
                                    </h3>
                                       <div class="flex justify-end order-first lg:order-last">
                        <label for="add-edit-modal" class="btn btn-outline btn-info btn-base" @click="setItem">
                            <span class="mt-0.5">{{ __('Add') }}</span>
                        </label>
                    </div>
                                </div>
                                <div class="rounded-2xl dark:bg-base-300 bg-white">
                                    <div class=" overflow-x-auto">
                                        <table class="table" v-if="saleRoute.items.length">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th> {{ __('Title') }} </th>
                                                    <th> {{ __('Action') }} </th>
                                                </tr>

                                            </thead>
                                            <draggable tag="tbody" v-model="saleRoute.items" handle=".drag-handle" item-key="id">
                                                <template #item="{ element, index }">
                                                    <tr>
                                                        <td class="drag-handle cursor-move flex font-bold"><ChevronUpDownIcon class="w-5 h-5" /> <span class="mr-3">{{ index + 1 }}</span></td>
                                                        <td> {{ element.title }} </td>
                                                        <td>
                                                            <label @click="setItem(element)" for="add-edit-modal"
                                                                class="btn btn-outline btn-info btn-sm mx-2">
                                                                {{ __('Edit') }}
                                                            </label>
                                                            <label @click="removeRoute(element,index)"
                                                                class="btn btn-outline btn-error btn-sm">
                                                                {{ __('Delete') }}
                                                            </label>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </draggable>
                                        </table>
                                        <div class="col-span-12 flex flex-col items-center mt-9" v-else>
                                            <NotFound />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="divider h-auto w-full"></div>
                            <div class="text-end">
                                <button type="submit" class="btn btn-primary px-6 mr-2">{{
                                    __('Save Changes')
                                }}</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <Teleport to="#app">
        <input type="checkbox" id="add-edit-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box bg-base-300">
                <h3 class="font-bold text-lg">{{ __(myRoute.position ? 'Edit route' : 'Add route') }}</h3>
                <Form @submit="setRoute" class="h-full flex flex-col px-4" v-slot="{ errors }">
                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium mt-3" for="">
                        {{ __('Title') }} <span class="text-error">*</span>
                    </label>
                    <Field as="input" name="text" :class="{ 'input-error': errors.title }" rules="required"
                        class="input" v-model="myRoute.title" />
                    <div class="modal-action">
                        <label for="add-edit-modal" class="btn btn-sm">{{ __('Refuse')
                        }}</label>
                        <button type="submit" class="btn btn-sm btn-info !ml-0 !mr-2">
                            {{ __(myRoute.position ? 'Edit' : 'Add') }}
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </Teleport>
      <Teleport to="#app">
        <input type="checkbox" id="delete-modal" class="modal-toggle" />
        <div class="modal">
            <Form class="modal-box" @submit="removeSaleProcess" v-slot="{ errors }">
                <h3 class="font-bold text-lg">{{ __('Delete process') }}</h3>
                <p class="py-4">{{ __('Before delete move sale process') }}</p>
                 <div class="flex flex-col">
                    <Field as="select" v-model="remove.move_to" :class="{ 'select-error': errors.move_to }" class="select" name="move_to" rules="required">
                        <option value="">{{ __('Select...') }}</option>
                        <option v-for="item in saleRoute.items.filter(item => item.id && item.id != remove.process_id)" :value="item.id">{{ item.title }}</option>
                    </Field>
                </div>
                <div class="modal-action">
                    <label class="btn btn-sm" for="delete-modal"
                        :class="{ 'pointer-events-none opacity-60': loadingBtn }">{{
                            __('Cancel') }}</label>
                    <button type="submit" class="btn btn-error btn-sm text-white"
                        :class="{ 'loading': loadingBtn }">
                        {{ __('Delete') }}
                    </button>
                </div>
            </Form>
        </div>
    </Teleport>
</template>

<script setup>
import { onMounted, ref } from 'vue';

import { Field, Form } from "vee-validate";
import draggable from 'vuedraggable'
import { ChevronUpDownIcon } from '@heroicons/vue/24/outline';
const { saleRoute, storeSaleRoute, editSaleRoute, updateSaleRoute,loadingBtn,removeSaleProcess,remove, loading, errors, route } = useDashboard();
const getData = () => {
    if (route.params.id) editSaleRoute();
    else loading.value = false;
}
const myRoute = ref({});
const onSubmit = () => {
    if (route.params.id) updateSaleRoute();
    else storeSaleRoute();
}

const removeRoute = (element,index) => {
    if(element.id) {
        remove.process_id = element.id;
        document.getElementById('delete-modal').checked = true;
    }else saleRoute.items.splice(index,1)
}

const setRoute = () => {
    if (!myRoute.value.position) saleRoute.items.push({ title: myRoute.value.title, position: saleRoute.items.length + 1 });
    else {
        const index = saleRoute.items.findIndex(item => item.position == myRoute.value.position);
        if (index != -1) saleRoute.items[index].title = myRoute.value.title;
    }
    document.getElementById('add-edit-modal').checked = false;
    myRoute.value = {};
}

const setItem = (item = {}) => myRoute.value = item;

onMounted(() => {
    getData();
});
</script>